import parser from 'html-react-parser';
import xss from 'xss';
import React from 'react';

export const toJSX = (
  htmlString: string,
  handleClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
) =>
  parser(
    xss(htmlString, {
      onTagAttr: (tag, name, value) => {
        if (name === 'class') {
          return `${name}="${value}"`;
        }
      },
    }),
    {
      replace: (domNode, index) => {
        if (domNode.type === 'tag' && domNode.name === 'a') {
          return React.createElement(
            'a',
            {
              key: index,
              href: domNode.attribs.href,
              className: domNode.attribs.class,
              onClick: handleClick,
              target: domNode.attribs.target,
            },
            domNode.children[0].type === 'text' ? domNode.children[0].data : '',
          );
        }
      },
    },
  );
